import { useSelector } from 'react-redux';
import { pipe } from 'fp-ts/function';
import { record } from 'fp-ts';
import { Stack } from '@optimus-web/core';
import { ApplicationState } from '@mews-commander/types';
import { getResourceCategoryIdOrd } from '@mews-commander/legacy-entities/src/ducks/spaces';
import { NoItems, SummaryRowBody } from '../../SummaryRow';
import { getServiceResourceCountsMap } from '../../../../../selectors';
import { ResourceCategoryName } from '../../../../../../../components';

interface ResourceCategoriesListProps {
    scope: string;
    serviceId: string;
}

const ResourceCategoriesList = ({ scope, serviceId }: ResourceCategoriesListProps) => {
    const resourceCategoryCountMap = useSelector((state: ApplicationState) =>
        getServiceResourceCountsMap(state, { serviceId, scope })
    );
    const ord = useSelector(getResourceCategoryIdOrd);

    if (record.isEmpty(resourceCategoryCountMap)) return <NoItems />;

    return (
        <Stack vertical spacing="100">
            {pipe(
                resourceCategoryCountMap,
                record.collect(ord)((resourceCategoryId, count) => (
                    <SummaryRowBody
                        text={<ResourceCategoryName serviceId={serviceId} id={resourceCategoryId} />}
                        count={count}
                        data-test-resource-category-id={resourceCategoryId}
                    />
                ))
            )}
        </Stack>
    );
};

export default ResourceCategoriesList;
